module.exports = __webpack_public_path__ + "static/media/logo.6ed3575b.svg";